import { useTranslation } from 'react-i18next'

import { ProfileInfoWidget } from '../../../Widget'

import { ORAG_CLUSTER_FIELDS } from './UserProfileWidgetOragCluster.constants'

function UserProfileWidgetOragCluster({
  canEdit,
  data,
  fieldVariables,
  isSkeleton,
  options,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ProfileInfoWidget
      canEdit={canEdit}
      config={ORAG_CLUSTER_FIELDS}
      data={data}
      fieldVariables={fieldVariables}
      isSkeleton={isSkeleton}
      options={options}
      title={t('Widget.OragClusterTitleKey')}
      onSubmit={onSubmit}
    />
  )
}

export default UserProfileWidgetOragCluster
